export default "__VITE_ASSET__3LLk_wOE__"